import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { addNewBuyer } from '../../Redux/BuyerRedux.js';

function Register({ toggleForm }) {
  const dispatch = useDispatch();
  const [otpSent, setOtpSent] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    emailId: '',
    phoneNumber: '',
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const { name, emailId, phoneNumber } = formData;
      if (
        name.trim() === '' ||
        emailId.trim() === '' ||
        phoneNumber.trim() === ''
      ) {
        toast.error('All fields are required.');
        return;
      }
      const data = { name, emailId, phoneNumber };
      await dispatch(addNewBuyer(data))
        .then(() => {
          toast.success(
            'Registration successful! OTP has been sent to your email.'
          );
          setOtpSent(true); // Set OTP sent state to true
        })
        .catch((error) => {
        console.error('Error in registration:', error);
        if (error.message === 'Email ID already exists') {
          toast.error('Email ID already exists');
        } else {
          toast.error('Failed to register');
        }
      });
    } catch (error) {
      console.error('Unexpected error:', error);
      // toast.error('An unexpected error occurred.');
    }
  };

  return (
    <div>
      <h5 className='text-center'>Register</h5>
      <div style={{ padding: '25px' }}>
        {!otpSent ? (
          <form onSubmit={handleRegister}>
            <div>
              <label htmlFor='name'>
                Name <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='text'
                id='name'
                name='name'
                className='form-control mb-3 mt-2'
                onChange={handleInputChange}
                style={{ border: '1px solid #cccccc' }}
                required
              />
            </div>
            <div>
              <label htmlFor='emailId'>
                Email Id <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='email'
                id='emailId'
                name='emailId'
                className='form-control mb-3 mt-2'
                onChange={handleInputChange}
                style={{ border: '1px solid #cccccc' }}
                required
              />
            </div>
            <div>
              <label htmlFor='phoneNumber'>
                Mobile Number <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='tel'
                id='phoneNumber'
                name='phoneNumber'
                className='form-control mb-3 mt-2'
                onChange={handleInputChange}
                style={{ border: '1px solid #cccccc' }}
                required
              />
            </div>
            <div className='row'>
              <div className='d-grid gap-2 col-8 mx-auto'>
                <button
                  className='btn'
                  style={{ background: '#2b6930', color: '#fff' }}
                  type='submit'
                >
                  Register
                </button>
              </div>
            </div>
          </form>
        ) : (
          <div className='text-center'>
            <p>
              Your registration was successful. An OTP has been sent to your
              registered email. Please use this OTP as your current password to
              log in. After logging in, go to the "Account Details" section on
              the account page to change your password and update the rest of
              your details and address.
            </p>
          </div>
        )}
        <div className='row mt-4'>
          <div className='col-12 text-center'>
            <Button
              onClick={() => {
                setOtpSent(false);
                toggleForm('login');
              }}
              fullWidth
              color='success'
            >
              Back to Login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
